var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("table", [
    _vm.hasHeaders
      ? _c("thead", [
          _c("tr", [
            _c("td", [
              _c(
                "div",
                { staticClass: "table-line-wrap" },
                [
                  _vm._l(_vm.layout.Payments.Cols, function (col, i) {
                    return [
                      col.HeaderField
                        ? _c(
                            "span",
                            { key: i, style: _vm.getHeadingStyle(i) },
                            [_vm._v(_vm._s(col.getHeadingText(_vm.lang)))]
                          )
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _c("tbody", [
      _c("tr", [
        _c("td", [
          _c(
            "div",
            { staticClass: "table-line-wrap" },
            _vm._l(_vm.layout.Payments.Cols, function (col, i) {
              return _c("span", { key: i, style: _vm.getStyle(i) }, [
                _vm._v(_vm._s(col.getText(_vm.lang))),
              ])
            }),
            0
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }